module.exports = __webpack_public_path__ + "static/media/icon-event__la-europa-de-entreguerras-hover.5dc55b10.svg";